var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 188,
    viewBox: "0 0 187 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_201_426",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 7,
    width: 177,
    height: 175
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.13306 7.01562H181.897V181.136H5.13306V7.01562Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_201_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.5148 7.04688C44.7061 7.04688 5.13306 46.62 5.13306 95.4286C5.13306 136.843 33.6511 171.496 72.0971 181.085C71.6846 179.892 71.4194 178.508 71.4194 176.792V161.685C67.8325 161.685 61.8228 161.685 60.3129 161.685C54.2658 161.685 48.8896 159.086 46.2822 154.254C43.3876 148.885 42.8867 140.673 35.713 135.65C33.5846 133.978 35.2048 132.07 37.6577 132.328C42.1871 133.61 45.9435 136.718 49.4784 141.328C52.9992 145.946 54.6564 146.992 61.2335 146.992C64.4225 146.992 69.1952 146.808 73.6877 146.101C76.1037 139.966 80.2799 134.317 85.3835 131.65C55.9526 128.623 41.9073 113.981 41.9073 94.1028C41.9073 85.5444 45.5529 77.2664 51.7472 70.2914C49.7145 63.3684 47.1586 49.2493 52.528 43.8726C65.7702 43.8726 73.7761 52.4606 75.6985 54.7804C82.2975 52.5194 89.5451 51.2377 97.1604 51.2377C104.791 51.2377 112.068 52.5194 118.682 54.795C120.582 52.4897 128.595 43.8726 141.867 43.8726C147.258 49.2565 144.673 63.4344 142.618 70.3429C148.776 77.3029 152.399 85.5595 152.399 94.1028C152.399 113.967 138.376 128.601 108.989 131.643C117.076 135.863 122.975 147.721 122.975 156.655V176.792C122.975 177.557 122.806 178.11 122.717 178.765C157.157 166.694 181.897 133.993 181.897 95.4286C181.897 46.62 142.323 7.04688 93.5148 7.04688Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.6b8a6fac11495f5584bbd0856021b4e9.svg";
export { ForwardRef as ReactComponent };